import styled from '@emotion/styled'
import StreamlineIcon from '@unowmooc/icons'

const Arrow = styled(StreamlineIcon)`
  font-size: 45px;
`

export default Arrow
